import { z } from 'zod';

export const RejectProposalServiceRequestSchema = z
  .object({
    campaignProposalId: z.number(),
  })
  .describe('RejectProposalServiceRequestSchema');

export type RejectProposalServiceRequest = z.infer<typeof RejectProposalServiceRequestSchema>;

export const RejectProposalServiceResponseSchema = z.object({
  campaignProposalId: z.number(),
});

export type RejectProposalServiceResponse = z.infer<typeof RejectProposalServiceResponseSchema>;
